
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexzBQolMDIDuHCXFyRuNAU8y8b_yb6KVssKnT7ZhNWA0oMeta } from "/Users/babythor/Documents/nagase/plastic/pages/index.vue?macro=true";
import { default as privacy_45policy5vhFkysie3PZrNr3CcSit2fys_jxw14RQ55RSEfOsB4Meta } from "/Users/babythor/Documents/nagase/plastic/pages/privacy-policy.vue?macro=true";
import { default as indexjawJi_455Glrs4zO3ZyO3Yh2V5rbV5Vmc_6ls7Zi_wNLAMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/index.vue?macro=true";
import { default as indexYLJ2QN4rHorkK_rWJp_45JxBiKq9iG0xGdSz_fz9e1m4EMeta } from "/Users/babythor/Documents/nagase/plastic/pages/services/index.vue?macro=true";
import { default as indexbLlwoAv_459XLEdwRFBAjka_gHIgQT2iRPbLvrFUIh34AMeta } from "/Users/babythor/Documents/nagase/plastic/pages/use-cases/index.vue?macro=true";
import { default as indexxysoO2RyC08No6XFvILqpPLDfdMLihdwvbZm_45_OWODcMeta } from "/Users/babythor/Documents/nagase/plastic/pages/contact-us/index.vue?macro=true";
import { default as indexaDiSUrpD4iBfE_NSrpVyFCUM_R_se1YtIJWyF9D3w3QMeta } from "/Users/babythor/Documents/nagase/plastic/pages/industries/index.vue?macro=true";
import { default as terms_45conditions7BjFZWv0_GFLcCT6Slwho3z5IyqS6usL_483_45pUypXoMeta } from "/Users/babythor/Documents/nagase/plastic/pages/terms-conditions.vue?macro=true";
import { default as indexx4WsgqkY2znASPqrClWhE3nRVa0Wnt9_Ann4Sxl_45jBIMeta } from "/Users/babythor/Documents/nagase/plastic/pages/about-nagase/index.vue?macro=true";
import { default as thank_45youSP4tXpBVp1pJEkTKDBqysmbHWmMjJG9IBl2LxX_fe6EMeta } from "/Users/babythor/Documents/nagase/plastic/pages/contact-us/thank-you.vue?macro=true";
import { default as index0urhNqMrrcnIbD_7zvfol1YWSXkbodwDqM6_457RgjbCIMeta } from "/Users/babythor/Documents/nagase/plastic/pages/sustainability/index.vue?macro=true";
import { default as indexYpsqnRp3JDSPXOkTYdLm_FP7nGDChL_45XDYD_45iKpl_u4Meta } from "/Users/babythor/Documents/nagase/plastic/pages/use-cases/adas/index.vue?macro=true";
import { default as indexWGg09fWzHM2N9aV2ZpV3Ne6eFA8ha6vrCqvYB9kkxxUMeta } from "/Users/babythor/Documents/nagase/plastic/pages/use-cases/exterior/index.vue?macro=true";
import { default as indexQefoir3WMHuYyj3f67Pa53AWIF8YmmI9ih5Ai9cnxP0Meta } from "/Users/babythor/Documents/nagase/plastic/pages/industries/infrastructure/index.vue?macro=true";
import { default as indexWrZJDkIG9ZYNJCFzDbWMzAfGZdmvcleGuoobDc2a_lsMeta } from "/Users/babythor/Documents/nagase/plastic/pages/industries/home-appliances/index.vue?macro=true";
import { default as index0ivtfZJWHks1GGLsRpdAmm1j5yytMihJd2HgkvuCA50Meta } from "/Users/babythor/Documents/nagase/plastic/pages/industries/medical-devices/index.vue?macro=true";
import { default as pp_452QV6zHH6NX7lE1Sbt4oVUBKY_45sPmUQP2cFSFtEdhT3IMMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/pp-2.vue?macro=true";
import { default as abs_452PLS634wL0GZzOWk1wuOplL_Zm1cT9Imr6mEFRD89Y40Meta } from "/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/abs-2.vue?macro=true";
import { default as index_v2fcG3mwNpK7sGq_45WEmxxH3MufhhheXlug8QNFgqHoMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/index.vue?macro=true";
import { default as pom_452fEdHH98S1e__krPvuAS_essUGitaqjWxWtgk6Zg401QMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/pom-2.vue?macro=true";
import { default as indexGfNecTg96LMjto9270aNTzvKW42RwkpqecgJ16ZPRekMeta } from "/Users/babythor/Documents/nagase/plastic/pages/services/logistics-supports/index.vue?macro=true";
import { default as indexwFdfqzJ1Xhol7_A2lsokqRMTcnyHz1mbHqA_45qhdlo74Meta } from "/Users/babythor/Documents/nagase/plastic/pages/industries/office-automation/index.vue?macro=true";
import { default as hips_4527gFQYqW85yw6hcNsQjvyLqXIXOg07oXeIvipRIYEXRQMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/hips-2.vue?macro=true";
import { default as indexGsA7w6_45S8dFK_vZZ3hQv6QX9JnpBoRG7y2Gj_y4dI1AMeta } from "/Users/babythor/Documents/nagase/plastic/pages/use-cases/ev-electrification/index.vue?macro=true";
import { default as indexAP37DXksRP_45kxj6IDV4IZ0Qj4irHW3QXitkePbVuHz0Meta } from "/Users/babythor/Documents/nagase/plastic/pages/products/engineering-plastics/index.vue?macro=true";
import { default as indexh63l_gWBjYHlCTR3Q8H_45wKXDpKG5F1rZ7_47EsltI_458Meta } from "/Users/babythor/Documents/nagase/plastic/pages/products/sustainable-plastics/index.vue?macro=true";
import { default as peiOs92XRDxQ6Y_45neFeCJHr_45nGq1A6ojvg7w6U4whQRZPYMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/pei.vue?macro=true";
import { default as indexRXuYJslU_456DvJg_31YdluAeMn83WMiP8rL0DnutLGFUMeta } from "/Users/babythor/Documents/nagase/plastic/pages/industries/electrical-electronics/index.vue?macro=true";
import { default as index71h2zizWr5hkxbTVuefuAarpWcRAp05AHx0oSCuKj4kMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/index.vue?macro=true";
import { default as lcp_4517i9DLvVhCU2nVTAb4_HISnrjhEKKMnQVR0rNUNd0iV8Meta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/lcp-1.vue?macro=true";
import { default as pes_452QkO79vXQCI2BFElrKnc1b5YPZ4k2Qwc6_45PacwJLW5TwMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/pes-2.vue?macro=true";
import { default as ppa_452jzrwQTLVSeninr8WYTwIVIexwNX3YpzC7Um4fi1iTKsMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/ppa-2.vue?macro=true";
import { default as pps_452nOfegQoiCRzLrtqympNMG1Sy_FBFCMgsCr6HMk_Km2kMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/pps-2.vue?macro=true";
import { default as psu_451BIxfnec7TjJHNVYCXi1RJX9WCiLFmkWZhC_X0J6Gw0IMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/psu-1.vue?macro=true";
import { default as indexaJJLWe2L_XjmoEmqkHLz3HYkekqwts9McsT2LpOScNMMeta } from "/Users/babythor/Documents/nagase/plastic/pages/services/technical-troubleshooting/index.vue?macro=true";
import { default as pa46_452iWQBhTuBjT_45rdsVtde_haOBvwI0BGtpU9r6Nfm8AjuMMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/pa46-2.vue?macro=true";
import { default as ppsu_4515nQ7UZg8gW59_455R4f4kVuUtpOe80jETVEQCRPDrE5NIMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/ppsu-1.vue?macro=true";
import { default as index_457fB1KTJbCYe00HyEHfMolRC4kZn2F1L9yO0SzhcmGUMeta } from "/Users/babythor/Documents/nagase/plastic/pages/use-cases/under-the-hood-powertrain/index.vue?macro=true";
import { default as indexvJNccCPqA2neBA_45yLofpDsBERWuf308mOi8P4wPCFh8Meta } from "/Users/babythor/Documents/nagase/plastic/pages/industries/automotive-and-e-mobility/index.vue?macro=true";
import { default as bio_45based_45materialF9FACXpeoL2E5Yg1qIuMemjlBvhv_zle_4557vx8KZmO8Meta } from "/Users/babythor/Documents/nagase/plastic/pages/products/sustainable-plastics/bio-based-material.vue?macro=true";
import { default as chemical_45recyclingv4IRVhUCWHniy2NPcxZjuHigbX1z675nD50nuzomUM4Meta } from "/Users/babythor/Documents/nagase/plastic/pages/products/sustainable-plastics/chemical-recycling.vue?macro=true";
import { default as mechanical_45recyclingSWtlBlUBTnPU_45__45UBo3KlTA_45ThHGY5TkvR8GRQ99QokMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/sustainable-plastics/mechanical-recycling.vue?macro=true";
import { default as specialty_45compoundDJfmQq3RshMa6lmaXRVUDsnbPAn5MDX3zmRHWweYdksMeta } from "/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/specialty-compound.vue?macro=true";
import { default as ev_45battery_45components23yFhEfXgBaIjTjUdWgBVsJNg_45sNYcgD3Qj3CWE5IWAMeta } from "/Users/babythor/Documents/nagase/plastic/pages/industries/automotive-and-e-mobility/ev-battery-components.vue?macro=true";
import { default as indexAREX5b4r38So9fJ_45yGv0yU114Er_45qd_K4rSLTrqFeNwMeta } from "/Users/babythor/Documents/nagase/plastic/pages/services/material-selection-products-development-support/index.vue?macro=true";
import { default as indexYhom7QzMfLShSfJ_ptA2cErpBw1SB30NXZpUtGDdF20Meta } from "/Users/babythor/Documents/nagase/plastic/pages/services/co2-calculation-visualization-service-by-zero-board/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/privacy-policy.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/index.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/services/index.vue")
  },
  {
    name: "use-cases",
    path: "/use-cases",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/use-cases/index.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    meta: indexxysoO2RyC08No6XFvILqpPLDfdMLihdwvbZm_45_OWODcMeta || {},
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/contact-us/index.vue")
  },
  {
    name: "industries",
    path: "/industries",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/industries/index.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/terms-conditions.vue")
  },
  {
    name: "about-nagase",
    path: "/about-nagase",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/about-nagase/index.vue")
  },
  {
    name: "contact-us-thank-you",
    path: "/contact-us/thank-you",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/contact-us/thank-you.vue")
  },
  {
    name: "sustainability",
    path: "/sustainability",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/sustainability/index.vue")
  },
  {
    name: "use-cases-adas",
    path: "/use-cases/adas",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/use-cases/adas/index.vue")
  },
  {
    name: "use-cases-exterior",
    path: "/use-cases/exterior",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/use-cases/exterior/index.vue")
  },
  {
    name: "industries-infrastructure",
    path: "/industries/infrastructure",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/industries/infrastructure/index.vue")
  },
  {
    name: "industries-home-appliances",
    path: "/industries/home-appliances",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/industries/home-appliances/index.vue")
  },
  {
    name: "industries-medical-devices",
    path: "/industries/medical-devices",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/industries/medical-devices/index.vue")
  },
  {
    name: "products-commodity-plastics-pp-2",
    path: "/products/commodity-plastics/pp-2",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/pp-2.vue")
  },
  {
    name: "products-commodity-plastics-abs-2",
    path: "/products/commodity-plastics/abs-2",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/abs-2.vue")
  },
  {
    name: "products-commodity-plastics",
    path: "/products/commodity-plastics",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/index.vue")
  },
  {
    name: "products-commodity-plastics-pom-2",
    path: "/products/commodity-plastics/pom-2",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/pom-2.vue")
  },
  {
    name: "services-logistics-supports",
    path: "/services/logistics-supports",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/services/logistics-supports/index.vue")
  },
  {
    name: "industries-office-automation",
    path: "/industries/office-automation",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/industries/office-automation/index.vue")
  },
  {
    name: "products-commodity-plastics-hips-2",
    path: "/products/commodity-plastics/hips-2",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/commodity-plastics/hips-2.vue")
  },
  {
    name: "use-cases-ev-electrification",
    path: "/use-cases/ev-electrification",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/use-cases/ev-electrification/index.vue")
  },
  {
    name: "products-engineering-plastics",
    path: "/products/engineering-plastics",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/engineering-plastics/index.vue")
  },
  {
    name: "products-sustainable-plastics",
    path: "/products/sustainable-plastics",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/sustainable-plastics/index.vue")
  },
  {
    name: "products-high-performance-plastics-pei",
    path: "/products/high-performance-plastics/pei",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/pei.vue")
  },
  {
    name: "industries-electrical-electronics",
    path: "/industries/electrical-electronics",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/industries/electrical-electronics/index.vue")
  },
  {
    name: "products-high-performance-plastics",
    path: "/products/high-performance-plastics",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/index.vue")
  },
  {
    name: "products-high-performance-plastics-lcp-1",
    path: "/products/high-performance-plastics/lcp-1",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/lcp-1.vue")
  },
  {
    name: "products-high-performance-plastics-pes-2",
    path: "/products/high-performance-plastics/pes-2",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/pes-2.vue")
  },
  {
    name: "products-high-performance-plastics-ppa-2",
    path: "/products/high-performance-plastics/ppa-2",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/ppa-2.vue")
  },
  {
    name: "products-high-performance-plastics-pps-2",
    path: "/products/high-performance-plastics/pps-2",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/pps-2.vue")
  },
  {
    name: "products-high-performance-plastics-psu-1",
    path: "/products/high-performance-plastics/psu-1",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/psu-1.vue")
  },
  {
    name: "services-technical-troubleshooting",
    path: "/services/technical-troubleshooting",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/services/technical-troubleshooting/index.vue")
  },
  {
    name: "products-high-performance-plastics-pa46-2",
    path: "/products/high-performance-plastics/pa46-2",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/pa46-2.vue")
  },
  {
    name: "products-high-performance-plastics-ppsu-1",
    path: "/products/high-performance-plastics/ppsu-1",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/ppsu-1.vue")
  },
  {
    name: "use-cases-under-the-hood-powertrain",
    path: "/use-cases/under-the-hood-powertrain",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/use-cases/under-the-hood-powertrain/index.vue")
  },
  {
    name: "industries-automotive-and-e-mobility",
    path: "/industries/automotive-and-e-mobility",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/industries/automotive-and-e-mobility/index.vue")
  },
  {
    name: "products-sustainable-plastics-bio-based-material",
    path: "/products/sustainable-plastics/bio-based-material",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/sustainable-plastics/bio-based-material.vue")
  },
  {
    name: "products-sustainable-plastics-chemical-recycling",
    path: "/products/sustainable-plastics/chemical-recycling",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/sustainable-plastics/chemical-recycling.vue")
  },
  {
    name: "products-sustainable-plastics-mechanical-recycling",
    path: "/products/sustainable-plastics/mechanical-recycling",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/sustainable-plastics/mechanical-recycling.vue")
  },
  {
    name: "products-high-performance-plastics-specialty-compound",
    path: "/products/high-performance-plastics/specialty-compound",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/products/high-performance-plastics/specialty-compound.vue")
  },
  {
    name: "industries-automotive-and-e-mobility-ev-battery-components",
    path: "/industries/automotive-and-e-mobility/ev-battery-components",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/industries/automotive-and-e-mobility/ev-battery-components.vue")
  },
  {
    name: "services-material-selection-products-development-support",
    path: "/services/material-selection-products-development-support",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/services/material-selection-products-development-support/index.vue")
  },
  {
    name: "services-co2-calculation-visualization-service-by-zero-board",
    path: "/services/co2-calculation-visualization-service-by-zero-board",
    component: () => import("/Users/babythor/Documents/nagase/plastic/pages/services/co2-calculation-visualization-service-by-zero-board/index.vue")
  }
]